import get from 'lodash/get';
import { getLoyaltyProgram } from './selector';
import { getActiveType, getActiveBrandShops } from '../../../auth/selectors';

export const getLoyaltyProgramInitialValues = (state) => {
  const loyaltyProgram = getLoyaltyProgram(state);
  const activeType = getActiveType(state);

  if (activeType !== 'brand') {
    return loyaltyProgram;
  }

  const brandShops = getActiveBrandShops(state) || [];
  const loyaltyShopIds = get(loyaltyProgram, 'brandShops', []).map(shop => shop.id);

  return {
    ...loyaltyProgram,
    shops: brandShops.map(shop => ({
      id: shop.id,
      assigned: loyaltyProgram.id ? loyaltyShopIds.includes(shop.id) : true,
      name: shop.name,
    })),
  };
};
